import { ApprovedIcon } from '@/assets/icons/info-icons/approved';
import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import { themeVar } from '@/styles/theme';
import styled from 'styled-components';

interface TransactionCompletedProps {
  isOpen: boolean;
  onClose: () => void;
}

const TransactionCompleted = ({ isOpen, onClose }: TransactionCompletedProps) => {
  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={onClose}
      showCancelButton={false}
      isUseOutsideClick={false}
      confirmButton={{ name: 'OK', onClick: onClose }}
    >
      <ModalBody alignItems="center">
        <ApprovedIcon width={60} height={60} />
        <ModalTitle>Transaction Completed</ModalTitle>
        <ModalDescription>All completed transactions can be found on the Compliance Tab.</ModalDescription>
      </ModalBody>
    </ModalWrappedContent>
  );
};

export default TransactionCompleted;

const ModalBody = styled.div<{ alignItems?: string }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ alignItems }) => alignItems || 'stretch'};
  gap: 10px;
`;

const ModalTitle = styled.h2`
  text-align: center;
  font-size: 33px;
  font-weight: 400;
  line-height: 46.2px;
  color: ${themeVar('font.strong')};
`;

const ModalDescription = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 22.4px;
  text-align: center;
  color: ${themeVar('font.base')};
`;
